import type { SVGProps } from 'react'
const LineCafe = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M8.5 2v.42c0 .332.132.651.365.885l.83.83c.517.516.805 1.217.805 1.945v.42H9v-.42c0-.332-.132-.651-.365-.885l-.83-.83A2.75 2.75 0 0 1 7 2.42V2zm4 0v.42c0 .332.132.651.365.885l.83.83c.517.516.805 1.217.805 1.945v.42H13v-.42c0-.332-.132-.651-.365-.885l-.83-.83A2.75 2.75 0 0 1 11 2.42V2zM5 9.25C5 8.56 5.56 8 6.25 8h14.5c.69 0 1.25.56 1.25 1.25v3.5a2.75 2.75 0 0 1-2.75 2.75h-.75v.75A2.75 2.75 0 0 1 15.75 19h-8A2.75 2.75 0 0 1 5 16.25zm12 .25H6.5v6.75c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25zm1.5 0V14h.75c.69 0 1.25-.56 1.25-1.25V9.5zm-13.44 11h13.88l1.78-1.78 1.06 1.06L19.56 22H4.44l-2.22-2.22 1.06-1.06z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineCafe }
